export default __webpack_public_path__ + "static/media/dashboard_result.20f77a83.svg";